import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FileSpreadsheet } from "lucide-react";
import { Logo } from "@/components/Layout";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Download() {
  const { token } = useParams();
  const href = `${API}/exports/file/${token}`;
  const [ok, setOk] = useState(null);
  useEffect(() => {
    fetch(href, { method: "HEAD" }).then((r) => setOk(r.ok)).catch(() => setOk(false));
  }, [href]);
  if (ok === false) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-slate-50 p-6 text-center" data-testid="download-invalid">
        <Logo className="h-12" />
        <p className="text-lg font-semibold text-slate-900">Enlace no válido o vencido</p>
        <p className="text-sm text-slate-500">Pide a tu administrador un enlace nuevo.</p>
      </div>
    );
  }
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-8 bg-slate-50 p-6 text-center" data-testid="download-page">
      <Logo className="h-12" />
      <div className="w-full max-w-md space-y-5 rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        <span className="inline-flex rounded-xl bg-teal-50 p-3 text-teal-700"><FileSpreadsheet className="h-7 w-7" /></span>
        <h1 className="text-2xl font-semibold text-slate-900">Descarga e-Plata</h1>
        <p className="text-sm text-slate-500">Archivo preparado por e-Plata para tu equipo.</p>
        <a href={href} download data-testid="download-file-btn"
          className="flex w-full items-center justify-center gap-2 rounded-lg bg-teal-600 px-4 py-3 font-medium text-white transition-colors hover:bg-teal-700">
          <FileSpreadsheet className="h-5 w-5" /> Descargar archivo
        </a>
        <p className="text-xs text-slate-400">Si no se descarga, mantén presionado el botón y elige "Descargar enlace", o abre esta página en Chrome o Safari.</p>
      </div>
    </div>
  );
}
